export default __webpack_public_path__ + "static/media/base-report12.abfa0445.png";